import { render } from "./DynamicBackground.vue?vue&type=template&id=428cbf6a"
import script from "./DynamicBackground.vue?vue&type=script&lang=js"
export * from "./DynamicBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__